import { render, staticRenderFns } from "./CFormType.vue?vue&type=template&id=43ab542d"
import script from "./CFormType.vue?vue&type=script&lang=js"
export * from "./CFormType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports